import React, { useEffect, useState } from "react";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import AllTransactionFilter from "./AllTransactionFilter";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import useAllTransactionColumn from "./Hook/useAllTransactionColumn";
import { useSelector } from "react-redux";
import { getAllTransactionList } from "./AllTransactionService";
import {
  setAllTransactionData,
  setTransactionData,
  setTransactionSorting,
} from "../../../slices/orders/orderSlice";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";
import { getOrgId } from "../../../Utils/CommonUtils";

function AllTransactionListing() {
  const { alltransactionColumn } = useAllTransactionColumn();

  // const selectedUser = useSelector((state) => state.header.selectedUser);
  const allTransactionData = useSelector(
    (state) => state.order.allTransactionData
  );
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector(
    (state) => state.order.transactionFilter.filterApi
  );
  const filterForm = useSelector((state) => state.order.transactionFilter.form);
  const sortColumn = useSelector(
    (state) => state.order.transactionSorting.column
  );
  const sortOrder = useSelector(
    (state) => state.order.transactionSorting.order
  );

  const enterpriseid = localStorage.getItem("enterpriseid");
  // const organizationId = getOrgId();
  const selectedUser = useSelector((state) => state.header.selectedUser);

  // const selectedUser = localStorage.getItem("selectedUser");
  // const organizationId = selectedUser ? JSON.parse(selectedUser).organizationid : "";

  // console.log("ortrganizationId", organizationId)

  return (
    <div>
      <CommonHeader
        formLink="/order/transaction/create"
        filterComponent={<AllTransactionFilter />}
        dash={true}
      />
      <div>
        {/* <TableWrapper
          columns={alltransactionColumn}
          data={allTransactionData}
        /> */}
        <TableWrapper
          columns={alltransactionColumn}
          data={allTransactionData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"PMT"}
          filterApiListEntity={"PMT"}
          filterApiFunction={setAllTransactionData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setTransactionSorting}
          enterpriseId={enterpriseid}
          organizationId={selectedUser.organizationid}
        />
      </div>
    </div>
  );
}

export default AllTransactionListing;
